<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}">
						<h4 class="card-title">
							<i class="material-icons" (click)="back()" style="cursor:pointer">arrow_left</i>
							Business Mail Intake
						</h4>
						<p class="card-category">Classify, review &amp; post inbound business email to the ERP</p>
					</div>
					<div class="card-body">

						<!-- Page actions -->
						<div class="row mb-3">
							<div class="col-12 d-flex justify-content-end gap-2 flex-wrap">
								<button mat-stroked-button type="button" (click)="openSettings()">
									<mat-icon>settings</mat-icon> Intake settings
								</button>
								<button mat-raised-button color="primary" (click)="triggerPoll()" [disabled]="loading">
									<mat-icon>sync</mat-icon> Poll mailbox
								</button>
							</div>
						</div>

						<div class="alert alert-warning py-2 small" *ngIf="lastPollErrors.length">
							Poll warnings: {{ lastPollErrors.join('; ') }}
						</div>

						<!-- Filters -->
						<div class="row mb-3 align-items-end">
							<div class="col-md-4">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>Kind</mat-label>
									<mat-select [(ngModel)]="filterKind" (selectionChange)="applyFilters()">
										<mat-option value="">All kinds</mat-option>
										<mat-option *ngFor="let k of kindsSchema?.kinds || []" [value]="k.id">{{ k.label }}</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
							<div class="col-md-4">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>State</mat-label>
									<mat-select [(ngModel)]="filterState" (selectionChange)="applyFilters()">
										<mat-option value="">All states</mat-option>
										<mat-option value="new">new</mat-option>
										<mat-option value="parsed">parsed</mat-option>
										<mat-option value="needs_review">needs_review</mat-option>
										<mat-option value="approved">approved</mat-option>
										<mat-option value="posted">posted</mat-option>
										<mat-option value="rejected">rejected</mat-option>
										<mat-option value="error">error</mat-option>
										<mat-option value="posted_partial">posted_partial</mat-option>
										<mat-option value="cancelled">cancelled</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>

						<div class="row">
							<!-- Queue -->
							<div class="col-md-5">
								<div class="card">
									<div class="card-header card-header-{{color}}">
										<h4 class="card-title">Queue</h4>
									</div>
									<div class="card-body">
										<div *ngIf="loading && !intakes.length" class="text-center py-4">
											<mat-spinner diameter="40"></mat-spinner>
										</div>
										<mat-nav-list *ngIf="!loading || intakes.length > 0">
											<mat-list-item *ngFor="let intake of intakes" (click)="selectIntake(intake)" [class.bg-light]="selectedIntake?.id === intake.id">
												<mat-icon matListIcon>email</mat-icon>
												<div matLine>{{ intake.subject }}</div>
												<div matLine class="text-muted small">{{ intake.intake_kind }} · {{ intake.sender_address }} · {{ intake.received_time | date:'short' }}</div>
												<mat-chip-list matLine>
													<mat-chip [color]="intake.state === 'new' || intake.state === 'parsed' || intake.state === 'needs_review' ? 'warn' : 'primary'" selected>{{ intake.state }}</mat-chip>
												</mat-chip-list>
											</mat-list-item>
										</mat-nav-list>
										<p class="text-muted text-center py-4 mb-0" *ngIf="!loading && !intakes.length">
											No intakes in the queue.
										</p>
									</div>
								</div>
							</div>

							<!-- Detail -->
							<div class="col-md-7" *ngIf="selectedIntake">
								<div class="card">
									<div class="card-header card-header-{{color}}">
										<h4 class="card-title">Intake #{{ selectedIntake.id }}</h4>
										<p class="card-category">{{ selectedIntake.subject }}</p>
									</div>
									<div class="card-body">
										<div class="mb-2 small text-muted">
											<strong>Kind:</strong> {{ selectedIntake.intake_kind }}
											<span *ngIf="selectedIntake.classification_confidence != null"> · confidence {{ selectedIntake.classification_confidence }}</span>
											<span *ngIf="selectedIntake.classification_reason"> · {{ selectedIntake.classification_reason }}</span>
										</div>
										<div class="mb-2 small text-danger" *ngIf="selectedIntake.error_msg">{{ selectedIntake.error_msg }}</div>
										<div class="mb-3">
											<strong>From:</strong> {{ selectedIntake.sender_address }}<br />
											<strong>Received:</strong> {{ selectedIntake.received_time | date:'medium' }}<br />
											<strong>Provider:</strong> {{ selectedIntake.provider }}
										</div>

										<div class="mb-3" *ngIf="attachments(selectedIntake).length">
											<h5>Attachments</h5>
											<ul class="list-unstyled small">
												<li *ngFor="let a of attachments(selectedIntake)">
													{{ a.name }} ({{ a.contentType }})
												</li>
											</ul>
										</div>

										<div class="mb-3" *ngIf="bodyText(selectedIntake)">
											<h5>Message text</h5>
											<div class="p-2 border rounded small" style="max-height: 220px; overflow-y: auto; white-space: pre-wrap">{{ bodyText(selectedIntake) }}</div>
										</div>

										<mat-divider class="my-3"></mat-divider>

										<h5>Line items</h5>
										<div *ngIf="showLineEditor()" class="mb-3">
											<div class="row g-2 align-items-center mb-2" *ngFor="let line of editableItems; let i = index">
												<div class="col-md-4">
													<mat-form-field appearance="outline" class="w-100">
														<mat-label>Stock / item</mat-label>
														<input matInput [(ngModel)]="line.stockid" />
													</mat-form-field>
												</div>
												<div class="col-md-3">
													<mat-form-field appearance="outline" class="w-100">
														<mat-label>Qty</mat-label>
														<input matInput type="number" [(ngModel)]="line.quantity" />
													</mat-form-field>
												</div>
												<div class="col-md-3">
													<mat-form-field appearance="outline" class="w-100">
														<mat-label>Unit price</mat-label>
														<input matInput type="number" [(ngModel)]="line.unitprice" />
													</mat-form-field>
												</div>
												<div class="col-md-2">
													<button mat-icon-button type="button" (click)="removeLine(i)" aria-label="Remove line">
														<mat-icon>delete</mat-icon>
													</button>
												</div>
											</div>
											<button mat-stroked-button type="button" (click)="addLine()">Add line</button>
											<button mat-stroked-button type="button" class="ms-2" (click)="reextract()" [disabled]="loading">Re-extract (AI)</button>
										</div>

										<div *ngIf="needsCustomer()" class="mb-3">
											<h5>Customer</h5>
											<app-customer-search (customerSelected)="selectedCustomer = $event"></app-customer-search>
											<div *ngIf="selectedCustomer" class="mt-2 small">
												Selected: <strong>{{ selectedCustomer.name }} ({{ selectedCustomer.debtorno }})</strong>
											</div>
										</div>

										<div *ngIf="needsVendor()" class="mb-3 small text-muted">
											Vendor: <strong>{{ selectedVendor?.supplierid || selectedIntake.parsed_json?.vendor?.supplierid || '— match in settings or map sender' }}</strong>
										</div>

										<div *ngIf="selectedIntake.intake_kind === 'payment_remittance'" class="mb-3">
											<mat-form-field appearance="outline">
												<mat-label>Payment amount</mat-label>
												<input matInput type="number" [(ngModel)]="paymentAmount" />
											</mat-form-field>
										</div>

										<div class="mb-3" *ngIf="previewResult?.preview">
											<h5>ERP preview (dry run)</h5>
											<pre class="bg-light p-2 rounded small">{{ previewResult.preview | json }}</pre>
										</div>

										<div class="my-3" *ngIf="selectedIntake.post_result_json">
											<h5>Last post result</h5>
											<pre class="bg-light p-2 rounded small">{{ selectedIntake.post_result_json | json }}</pre>
											<button mat-stroked-button type="button" *ngIf="selectedIntake.post_result_json?.deeplink" (click)="openPostOrderLink()">Open document</button>
										</div>

										<mat-divider class="my-3"></mat-divider>

										<h5>Reclassify</h5>
										<mat-form-field appearance="outline" class="w-100 mb-2">
											<mat-label>Intake kind</mat-label>
											<mat-select [(ngModel)]="reclassifyKind">
												<mat-option *ngFor="let k of kindsSchema?.kinds || []" [value]="k.id">{{ k.label }}</mat-option>
											</mat-select>
										</mat-form-field>
										<button mat-stroked-button type="button" (click)="reclassify(reclassifyKind)" [disabled]="loading || !reclassifyKind">Apply kind</button>

										<mat-divider class="my-3"></mat-divider>

										<h5>Audit trail</h5>
										<div class="small" *ngIf="auditRows.length">
											<div *ngFor="let a of auditRows" class="mb-1 border-bottom pb-1">
												<strong>{{ a.action }}</strong> · {{ a.created_at | date:'short' }}
												<span *ngIf="a.userid"> · {{ a.userid }}</span>
												<pre class="mb-0 mt-1 bg-light p-1 rounded" *ngIf="a.payload_json">{{ a.payload_json | json }}</pre>
											</div>
										</div>
										<p class="text-muted" *ngIf="!auditRows.length">No audit entries yet.</p>
									</div>
									<div class="card-footer d-flex justify-content-end gap-2" *ngIf="showPostActions()">
										<button mat-button color="warn" type="button" (click)="reject()" [disabled]="loading">Reject</button>
										<button mat-stroked-button type="button" (click)="previewPost()" [disabled]="loading">Preview ERP post</button>
										<button mat-raised-button color="primary" type="button" (click)="commitPost()" [disabled]="loading || !confirmToken">Commit post</button>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>
